module.exports = __webpack_public_path__ + "img/baerbock-lebenslauf.7ac0fd61.png";